import { h } from "preact";
import { useState, useContext } from "preact/hooks";
import { APARTMENT_FORM_TYPE } from "../../ApartmentForm.types";
import { useFetchAccounts } from "../hooks/useGetAccounts";

export default function AddressStep({ type, onNext, formContext, props }) {
  const { accounts, loading } = useFetchAccounts(
    props.getAccountsUrl,
    props.accountId
  );

  const { formData } = useContext(formContext);
  const [selectedAddress, setSelectedAddress] = useState(
    accounts.find((addr) => addr.address === formData.address) || null
  );

  const handleSubmit = () => {
    if (selectedAddress) {
      onNext({
        address: selectedAddress.address,
        accountNumber: selectedAddress.id,
        debtAmount: selectedAddress.contracts[0].debtAmount,
        contractId: selectedAddress.contracts[0].id,
      });
    }
  };

  return (
    <div className="address-step">
      <h1>Выберите адрес объекта</h1>

      <div className="form-block__line" style={{ maxWidth: "576px" }}>
        <div className="form-field">
          <div className="form-field__inner">
            <div className="form-field__input-row">
              <div className="select form-field__select js__tabselect">
                <button
                  className="select__button select__button--addressForm"
                  data-dsdd=""
                >
                  {!!selectedAddress && <span>{selectedAddress.address}</span>}
                </button>

                <ul className="select__list dsdd-menu">
                  {loading && (
                    <li className="select__item">
                      <label className="select__label">
                        ...загрузка, ожидайте
                      </label>
                    </li>
                  )}
                  {!loading &&
                    accounts.map((account) => (
                      <li className="select__item" key={account.id}>
                        <input
                          className="select__input"
                          name="address"
                          type="radio"
                          checked={selectedAddress?.id === account.id}
                          onChange={() => setSelectedAddress(account)}
                        />
                        <label
                          className="select__label"
                          onClick={() => setSelectedAddress(account)}
                        >
                          <span>{account.address}</span>
                        </label>
                      </li>
                    ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div>
        <button
          className="button-primary"
          data-modal-url="/account/add/"
          data-reach-goal="adress_add"
        >
          Нет нужного адреса
        </button>
      </div>

      <button
        className="button-primary"
        onClick={handleSubmit}
        disabled={!selectedAddress || selectedAddress.id === '0'}
      >
        Далее
      </button>
    </div>
  );
}
